<template>
    <CSidebar
        position="fixed"
        :unfoldable="sidebarUnfoldable"
        :visible="sidebarVisible"
        @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
    >
        <CSidebarBrand id="sidebar__header">
            <img id="sidebar__logo" :src="logoActual" class="sidebar-brand-full">
        </CSidebarBrand>
          <div class="p-2 text-center">
            Bienvenido {{authInfo.name}}
            <div class="small">
                {{authInfo.username}}
            </div>
        </div>
        <hr class="mb-2 mt-1"/>
        <ContainerMenu/>
        <CSidebarToggler
            class="d-none d-lg-flex"
            @click="$store.commit('toggleUnfoldable')"
        />
    </CSidebar>
</template>

<script>
import {computed, ref, onMounted} from 'vue'
import {mapGetters, useStore} from 'vuex'
import ContainerMenu from './ContainerMenu.vue'
import logoNegative from '@/assets/images/logo.png'
import {sygnet} from '@/assets/brand/sygnet'
import {config} from '@/config'

export default {
    name: 'AppSidebar',
    components: {
        ContainerMenu,
    },
    setup() {
        const store = useStore()
        const logoActual = ref(logoNegative)

        /**
         * Cargar logo personalizado desde la configuración de personalización
         * Si existe un logo custom, lo usa; caso contrario usa el logo por defecto
         */
        onMounted(async () => {
            try {
                const response = await fetch(`${config.backendUrl}/personalizacion/public`)
                if (response.ok) {
                    const data = await response.json()
                    if (data.status && data.data && data.data.logo) {
                        // El backend ya retorna la URL completa con asset()
                        logoActual.value = data.data.logo
                    }
                }
            } catch (error) {
                console.warn('No se pudo cargar logo personalizado:', error)
            }
        })

        return {
            logoNegative,
            logoActual,
            sygnet,
            sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
            sidebarVisible: computed(() => store.state.sidebarVisible),
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading',
            authInfo: 'authInfo',
        })
    },
}
</script>
